import { useEffect, useRef } from "react";
import { BrandName } from "./brand-name";
import { gsap } from "gsap";
import useAnimationStore from "../stores/use-animation";
import LogoSvg from "./logo-svg";
import chillChord from "../assets/audio/chill-chords.mp3"
import { Howl } from 'howler';


export default function Logo() {

  const isStart = useAnimationStore((state) => state.isStart);
  const { calculateScale, isShowResult } = useAnimationStore();
  const chillSound = useRef()
  const timeline = useRef()
  useEffect(() => {
    chillSound.current = new Howl({
      src: [chillChord],
      loop: true,
      volume: 0.1,
      rate: 1.5,
    });
    timeline.current = gsap.timeline({ paused: true, })
  .to("#logo", {height: window.innerHeight, width:window.innerWidth, transformOrigin: "50% 50%"})
  .to(".bottom > .mid",{ y:50, opacity: 0},">")
  .to(".bottom > .right",{ y:50, x:50, opacity: 0},"<")
  .to(".bottom > .left",{ y:50, x:-50, opacity: 0},"<")
  .to(".top > .mid",{ y:-50, opacity: 0}, "<")
  .to(".top > .right",{ y:-50, x:50, opacity: 0}, "<")
  .to(".top > .left",{ y:-50, x:-50, opacity: 0}, "<")
  .to("#inline", {
    scale: 0.9,
    duration: 1,
    repeat: -1,
    transformOrigin: "center center",
    yoyo: true

  })
  .to("#outline", {
    scale: 1.3,
    color: "black",
    opacity: 0,
    duration: 2,
    repeat: -1,
    transformOrigin: "center center"
  }, "<")
  .to("#outline-2", {
    scale: 1.1,
    color: "black",
    opacity: 0,
    duration: 2,
    repeat: -1,
    transformOrigin: "center center"
  }, "<")
  .to("#pupil", {
    duration: 0.1,
    x: "random(-4, 4)",
    y: "random(-4, 4)",
    repeat: -1, // Lặp lại mãi mãi
    yoyo: true, // Quay lại vị trí ban đầu
    ease: "sine.inOut", // Hiệu ứng mượt mà
    stagger: 0.05 // Cách biệt giữa các lần lắc
  }, ">")

    return () => {
      timeline.current.kill()
    }
  }, [])

  useEffect(() => {
    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;
    // Tính toán tỷ lệ scale
    calculateScale(svgRef.current, screenWidth, screenHeight);
  }, [calculateScale]);






  // .to("#pupil", { scale:20, transformOrigin: "50% 50%"},">")

  const svgRef = useRef(null);



  useEffect(() => {
    const pupil = document.getElementById("pupil");
    const centerX = 165.247; // Tâm tròn lớn (cx)
    const centerY = 161.247; // Tâm tròn lớn (cy)
    const maxRadius = 8; // Bán kính di chuyển tối đa của pupil

    if (isStart) {

      timeline.current.play()
      gsap.to(pupil, { attr: { cx: centerX, cy: centerY } });


    }


    const handleMouseMove = (event) => {
      if (isStart) {
        // Khi hiệu ứng dừng, pupil trở về trung tâm
        return;
      }

      const { clientX, clientY } = event;
      const svgElement = document.querySelector("svg");
      const rect = svgElement.getBoundingClientRect();

      const mouseX = clientX - rect.left;
      const mouseY = clientY - rect.top;

      const dx = mouseX - centerX;
      const dy = mouseY - centerY;
      const distance = Math.sqrt(dx * dx + dy * dy);

      const limitedX =
        distance > maxRadius
          ? centerX + (dx / distance) * maxRadius
          : mouseX;
      const limitedY =
        distance > maxRadius
          ? centerY + (dy / distance) * maxRadius
          : mouseY;

      gsap.to(pupil, { attr: { cx: limitedX, cy: limitedY }, duration: 0.1 });
    };

    window.addEventListener("mousemove", handleMouseMove);

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
    };
  }, [isStart]);
  useEffect(() => {
    if (isStart) {
      if (isShowResult) {
        chillSound.current.volume(0.6)
        chillSound.current.stop()
      }
      else  {
      setTimeout(() => {
        chillSound.current.play()
        chillSound.current.fade(0.1, 0.2, 1000);
      }, 1000);

      }
    }



  }, [isStart, isShowResult])

  return (
    <div>
      <LogoSvg ref={svgRef}/>
      {isStart ?
      null
      :
        <BrandName />
        }
    </div>
  );
}
